// Malphite — Unstoppable Force: Slams into the enemy frontline, dealing massive magic
// damage to the front enemy and AOE to the next 2. Stuns all hit for 1 turn.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const malphiteUltimate: Ability = {
  id: "malphiteUltimate",
  displayName: "Unstoppable Force",
  description: "Slams into the front 3 enemies for magic damage and stuns them for 1 turn.",
  iconId: "MalphiteR",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(team)
      .sort((a, b) => a.pos.q - b.pos.q)
      .slice(0, 3)
      .map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const targets = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q).slice(0, 3);
    const stats = effectiveStats(caster);

    return targets.map((target, i) => ({
      target,
      amount: magicDamage(stats.ap * (i === 0 ? 1.4 : 0.8) + (i === 0 ? 100 : 60)),
      type: "magical" as const,
      effect: { kind: "stun" as const, duration: 1 },
      suppressPopup: i > 0,
    }));
  },
};
